function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { List, Button, Space, Tag, Modal, Drawer, Image, notification } from "antd";
import Common from "./includes/Common";
import { BoxFill, Plus } from "react-bootstrap-icons";
import EditItem from "./forms/EditItem";
import AddOfficeProvision from "./forms/AddOfficeProvision";
import EditSellable from "./forms/EditSellable";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var ItemList = function ItemList(_ref) {
  var refresh = _ref.refresh;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataChanged = _useState6[0],
    setIsDataChanged = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    loadError = _useState8[0],
    setLoadError = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showEdit = _useState0[0],
    setShowEdit = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedItem = _useState10[0],
    setSelectedItem = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showAddOfficeProvision = _useState12[0],
    setShowAddOfficeProvision = _useState12[1];
  useEffect(function () {
    setIsDataChanged(false);
    setIsDataChanged(false);
    axios.get("".concat(Common.baseApiUrl, "getsellables/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setItems(response.data.sellables);
      } else {
        setLoadError(response.data.message);
      }
    })["catch"](function (error) {
      setLoadError("Une erreur est survenue " + error.toString());
    })["finally"](function () {});
  }, [refresh, isDataChanged]);
  var handleDelete = function handleDelete(item) {
    setSelectedItem(item);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression de ", item.label, " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deletesellable", {
          user_id: Common.currentUser.id,
          item_id: item.id.toString()
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      dataSource: items,
      itemLayout: "horizontal",
      renderItem: function renderItem(item, index) {
        return /*#__PURE__*/_jsx(List.Item, {
          actions: [/*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedItem(item);
              setShowEdit(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "MODIFIER"
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              handleDelete(item);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "SUPPRIMER"
            })
          })],
          children: /*#__PURE__*/_jsx(List.Item.Meta, {
            avatar: /*#__PURE__*/_jsx(Image, {
              src: Common.baseUrl + item.picture,
              fallback: "/drawables/sc.png",
              preview: false,
              width: "40px"
            }),
            title: item.label,
            description: /*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Prix : "
                }), item.price.toLocaleString("Fr")]
              }), " ", /*#__PURE__*/_jsx(Tag, {
                color: "rgb(0, 128, 255)",
                children: item.sellable_category.label
              }), " ", /*#__PURE__*/_jsx(Tag, {
                color: "#f50",
                children: item.provider.label
              })]
            })
          })
        });
      }
    }), selectedItem && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        open: showEdit,
        onClose: function onClose() {
          setShowEdit(false);
        },
        width: "400px",
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFICATION"
        }),
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(EditSellable, {
          item: selectedItem,
          handler: function handler() {
            setShowEdit(false);
            setIsDataChanged(true);
            notification.success({
              message: "Ok!"
            });
          }
        })
      })
    })]
  });
};
export default ItemList;